import styled from 'styled-components';
// import { PURPLE, WHITE } from '@colors';

const Wrapper = styled.div`
  height: 100%;
`;

export { Wrapper };
